import * as yup from 'yup';
import { translate } from '../../../shared/i18n';

export const schemaFormCreate = yup.object().shape({
  title: yup
    .string()
    .required(translate('modelsFormsCreateEdit.validation.titleRequired')),
  inputs: yup
    .array()
    .min(1, translate('modelsFormsCreateEdit.validation.missingInputs')),
});

export const schemaFormEdit = yup.object().shape({
  title: yup
    .string()
    .required(translate('modelsFormsCreateEdit.validation.titleRequired')),
});
